import { render, staticRenderFns } from "./Disparity.vue?vue&type=template&id=6d5cd9e2&scoped=true"
import script from "./Disparity.vue?vue&type=script&lang=js"
export * from "./Disparity.vue?vue&type=script&lang=js"
import style0 from "./Disparity.vue?vue&type=style&index=0&id=6d5cd9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5cd9e2",
  null
  
)

export default component.exports